function updateCartCounter(count) {
  var counterElements = document.querySelectorAll(".cart-counter");
  counterElements.forEach(function (counterElement) {
    counterElement.textContent = "" + count + "";
  });
}

// Function to fetch cart data and update the counter
function updateCartCounterFromAPI() {
  theme.cart.getCart().then(function (cartData) {
    var itemCount = cartData.item_count || 0;
    updateCartCounter(itemCount);
  });
}

// Listen for cart updates and update the counter
document.addEventListener("cart:updated", function (event) {
  var itemCount = event.detail.cart.item_count || 0;
  updateCartCounter(itemCount);
});

document.addEventListener("ajaxProduct:added", () => {
  updateCartCounterFromAPI();
});
